import * as C from 'io-ts/Codec';
import { PdfMetadata } from 'src/modules/common/types/PdfMetadata';

export const PDF_METADATA: C.Codec<unknown, PdfMetadata, PdfMetadata> = C.struct({
  pageCount: C.number,
});
